export default __webpack_public_path__ + "static/media/footSide.fa888c32.jpg";